import {
  Text,
  Icon,
  Button,
  PaginationDots,
  Slider,
  useSliderController,
} from "@ui-component-library";

const customerReviews = [
  {
    quote:
      "Jag kan verkligen rekommendera Treebula till andra skogsägare. Hela upplevelsen har varit väldigt positiv och jag kommer att använda Treebula igen.",
    name: "Mikael Andersson",
    profession: "Skogsägare, Sala",
  },
  {
    quote:
      "“Det var väldigt enkelt att skapa annonsen och man fick väldigt bra hjälp. Hela tiden har man en kontaktperson hos Treebula som kan hjälpa till och svara på frågor.",
    name: "Mårten Karlsson",
    profession: "Skogsägare, Årjäng",
  },
  {
    quote:
      "Det var inte bara de vanliga köparna, dem man känner till. Jag fick anbud av köpare som jag inte ens visste fanns.",
    name: "Daniel Johansson",
    profession: "Skogsägare, Uppland",
  },
];

export default function ReviewSlider() {
  const [sliderProps, slider] = useSliderController();

  return (
    <div className="w-full bg-[#E5E1DC] min-h-[364px]">
      <div className="max-w-[1320px] mx-auto flex flex-col">
        <section className="flex flex-col gap-12">
          <div className="relative">
            <Slider {...sliderProps} desktopVisible={1} mobileVisible={1}>
              {customerReviews.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-center items-center gap-4 flex-col min-h-[375px] max-w-[864px] mx-auto"
                >
                  <Text
                    variant="text-3xl/leading-normal/medium"
                    className="text-[95px] mb-[-64px] leading-none self-start"
                  >
                    ”
                  </Text>
                  <Text
                    variant="text-3xl/leading-normal/medium"
                    className="mb-8"
                  >
                    {item.quote}
                  </Text>
                  <div className="flex items-center flex-row gap-1">
                    <Text
                      variant="text-sm/leading-normal/normal"
                    >
                      {item.name}
                    </Text>
                    <Text
                      variant="text-sm/leading-normal/normal"
                      className="text-[#737373]"
                    >
                      - {item.profession}
                    </Text>
                  </div>
                </div>
              ))}
            </Slider>

            <div className="flex justify-between items-center mt-12">
              <PaginationDots
                total={customerReviews.length}
                activeIndex={slider.currentSlide}
                onDotSelect={slider.goToSlide}
              />

              <div className="flex gap-3">
                <Button
                  tw
                  variant="primary"
                  onClick={slider.prev}
                  disabled={slider.isFirstSlide}
                  className="disabled:opacity-30"
                >
                  <Icon tw name="ArrowShortSimple" size="medium" className="fill-[#FBFBFB]" />
                </Button>

                <Button
                  tw
                  variant="primary"
                  onClick={slider.next}
                  disabled={slider.isLastSlide}
                  className="disabled:opacity-30"
                >
                  <Icon tw name="ArrowShortSimple" size="medium" className="rotate-180 fill-[#FBFBFB]" />
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
